import React, { Component } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { NamespacesConsumer as I18n } from "react-i18next"
import { NotificationContainer } from "react-notifications"
import { Link, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { compose } from "redux"
// import { API, graphqlOperation } from "aws-amplify"

//component
import Route from "../Route"
import MenuDrawers from "./NavBarMobile/MenuDrawers"
// import { tagOptions } from "../containers/ConstData/consNotification"
import MenuNavbarMobile from "./NavBarMobile/MenuNavbarMobile"
import Footerarea from "../components/Footer_area"
import * as user_actions from "../actions/action_user"
import * as notification_actions from "../actions/action_notification"
// import { subscription } from "../graphql/subscription"
import { handlelocalstorageClear } from "../containers/Registration/PostMessage"

//material ui
import PropTypes from "prop-types"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
// import Badge from "@material-ui/core/Badge"
import { withStyles } from "@material-ui/core/styles"
import MenuIcon from "@material-ui/icons/Menu"
// import NotificationsIcon from "@material-ui/icons/Notifications"
import { styles } from "../containers/Style/NavBarMobileStyle"

class NavBarMobile extends Component {
	constructor(props) {
		super(props)
		this.state = {
			NotificationMenu: null,
			left: false,
			statuspush: false,
			open: false
		}
	}
	componentDidMount() {
		this.handleRestorename(this.props)
	}
	UNSAFE_componentWillReceiveProps(nextPorps) {
		this.setState({ statuspush: false })
		this.handleRestorename(nextPorps)
	}
	handlepush = () => {
		if (!this.state.statuspush) {
			this.props.history.push("/Restorename")
			this.setState({ statuspush: true })
		}
	}
	// async componentDidUpdate() {
	// 	if (Object.keys(this.props.user).length !== 0) {
	// 		API.graphql(
	// 			graphqlOperation(subscription(this.props.userInfo.user_id))
	// 		).subscribe({
	// 			next: todoData =>
	// 				this.props.subscription_notification(
	// 					todoData.value.data.notificationUser
	// 				)
	// 		})
	// 	}
	// }
	handleRestorename = (items) => {
		if (Object.keys(items.userInfo).length > 0) {
			if (
				Object.keys(items.user).length !== 0 &&
				!!!items.userInfo.given_name &&
				!!!items.userInfo.family_name
			) {
				this.handlepush()
			}
		}
	}
	toggleDrawer = (side, open) => () => {
		this.setState({
			[side]: open
		})
	}
	handleNotificationMenuOpen = (event) => {
		this.setState({ NotificationMenu: event.currentTarget })
	}
	handleNotificationMenuClose = () => {
		this.setState({ NotificationMenu: null })
	}

	handleLogout = (event) => {
		event.preventDefault()
		this.props
			.logout_local()
			.then((res) => {
				handlelocalstorageClear()
				this.props.history.push("/Signin")
				this.toggleDrawer("left", false)
			})
			.catch((err) => {})
	}
	handlegetnotidefault = async () => {
		const { userInfo } = this.props
		await this.props.get_notification(userInfo.user_id, null)
	}
	handlegetnotification = async () => {
		const { userInfo, LastEvaluatedKey } = this.props
		await this.props.get_notification(userInfo.user_id, LastEvaluatedKey)
	}
	render() {
		const { NotificationMenu, left } = this.state
		const { classes, user, notification } = this.props
		const isNotificationMenuOpen = Boolean(NotificationMenu)
		return (
			<I18n>
				{(t, { i18n }) => {
					return (
						<div className={classes.root}>
							<AppBar position="static" className={classes.AppBarcolor}>
								<Toolbar className={classes.Toolbar}>
									<div
										className="col-lg-2 col-md-2 col-sm-2"
										style={{
											textAlign: "left"
										}}
									>
										<IconButton
											color="inherit"
											aria-label="Open drawer"
											onClick={this.toggleDrawer("left", true)}
										>
											<MenuIcon />
										</IconButton>
									</div>
									<div
										className="col-lg-8 col-md-8 col-sm-8"
										style={{
											textAlign: "-webkit-center"
										}}
									>
										<Link to="/" aria-label="logo">
											<LazyLoadImage
												alt="logo"
												src="/new-MMA-logo.png"
												width="70px"
												height="70px"
											/>
										</Link>
									</div>
									<div
										className="col-lg-2 col-md-2 col-sm-2"
										style={{
											textAlign: "right"
										}}
									>
										{/* <IconButton
											aria-label="NotificationsIcon"
											color="inherit"
											onClick={this.handleNotificationMenuOpen}
										>
											<Badge badgeContent={tagOptions.length} color="secondary">
												<NotificationsIcon />
											</Badge>
										</IconButton> */}
									</div>
								</Toolbar>
							</AppBar>
							<MenuDrawers
								{...this.props}
								classes={classes}
								t={t}
								left={left}
								i18n={i18n}
								toggleDrawer={this.toggleDrawer}
								handleLogout={this.handleLogout}
								user={user}
							/>
							<MenuNavbarMobile
								{...this.props}
								classes={classes}
								handlegetnotidefault={this.handlegetnotidefault}
								notification={notification}
								NotificationMenu={NotificationMenu}
								isNotificationMenuOpen={isNotificationMenuOpen}
								handleNotificationMenuClose={this.handleNotificationMenuClose}
							/>

							<Route />
							<Footerarea {...this.props} user={user} />

							<NotificationContainer />
						</div>
					)
				}}
			</I18n>
		)
	}
}
NavBarMobile.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo,
		notification: reduxState.NotificationReducer.notification,
		loading: reduxState.NotificationReducer.loading,
		LastEvaluatedKey: reduxState.NotificationReducer.LastEvaluatedKey
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		logout_local: () => dispatch(user_actions.logout_local()),
		get_notification: (user_id, next_token) =>
			dispatch(notification_actions.get_notification(user_id, next_token)),
		subscription_notification: (data) =>
			dispatch(notification_actions.subscription_notification(data))
	}
}
export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(NavBarMobile)
